module.exports = __webpack_public_path__ + "assets/img/240301.1d74e388.png";